"use client";

import { SafeHydrate } from "@/SafeHydrate";
import * as React from "react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Drawer, DrawerClose, DrawerContent, DrawerDescription, DrawerFooter, DrawerHeader, DrawerTitle, DrawerTrigger } from "@/components/ui/drawer";
const teamMembers = [{
  name: "Elena Vance",
  position: "Lead Photographer",
  bio: "Elena finds beauty in the quiet, unscripted moments. With a background in fine art, she approaches every wedding as a unique narrative, focusing on soft natural light and the delicate emotions that define your relationship. Her favorite light? The golden hour just before dusk.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675594/img/artist_elena_vance.png"
}, {
  name: "Julian Thorne",
  position: "Creative Director",
  bio: "Julian is the architect of Ivory Lens's signature aesthetic. He specializes in editorial composition and timeless styling, ensuring every frame feels like a piece of art. Why photography? Because it's the only way to truly pause time and preserve a feeling forever.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675594/img/artist_julian_thorne.png"
}, {
  name: "Sophia Chen",
  position: "Studio Manager",
  bio: "Sophia ensures your experience is as seamless as our imagery. From the first inquiry to the final album delivery, she is your dedicated guide. She believes that the best photographs happen when couples feel completely at ease and truly seen.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675594/img/artist_sophia_chen.png"
}];
export default function TheMindsBehindServa() {
  return <section data-section-id="235828" id="meet-the-artists" className="py-24 bg-background text-foreground relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-accent/20 rounded-lg blur-3xl -z-10 pointer-events-none" />
      <div className="absolute bottom-0 right-1/4 w-[30rem] h-[30rem] bg-secondary/30 rounded-lg blur-3xl -z-10 pointer-events-none" />

      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center max-w-3xl mx-auto mb-16 space-y-4">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-default font-light text-foreground tracking-tight">
            Meet the Artists
          </h2>
          <p className="text-lg text-muted-foreground font-sans leading-relaxed">
            The creative souls dedicated to capturing your most cherished memories with refined nostalgia.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12">
          {teamMembers.map((member, i) => <SafeHydrate><Drawer key={member.name}>
              <DrawerTrigger asChild>
                <div data-index={i} className="group cursor-pointer flex flex-col items-center text-center p-8 rounded-lg border border-border bg-card/30 backdrop-blur-sm hover:bg-card/60 transition-all duration-500 shadow-sm hover:shadow-lg">
                  <div className="relative w-48 h-48 mb-6 overflow-hidden rounded-lg border-2 border-background shadow-md">
                    <img src={member.image} alt={`Portrait of ${member.name}`} className="w-full h-full object-cover grayscale opacity-90 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-700 ease-in-out transform group-hover:scale-105" />
                  </div>
                  <h3 className="font-default text-2xl font-regular text-foreground mb-3">
                    {member.name}
                  </h3>
                  <Badge variant="secondary" className="px-3 py-1 text-xs tracking-widest uppercase font-sans font-light bg-secondary/50 text-secondary-foreground">
                    {member.position}
                  </Badge>
                </div>
              </DrawerTrigger>
              <DrawerContent className="bg-background border-t border-border">
                <div className="mx-auto w-full max-w-md">
                  <DrawerHeader className="text-center sm:text-center">
                    <DrawerTitle className="font-default text-3xl sm:text-4xl mb-1 font-light">
                      {member.name}
                    </DrawerTitle>
                    <DrawerDescription className="text-base font-sans font-light tracking-wide text-primary uppercase">
                      {member.position}
                    </DrawerDescription>
                  </DrawerHeader>
                  <div className="p-6 pb-0 flex flex-col items-center space-y-6">
                    <Avatar className="w-32 h-32 border-2 border-border shadow-lg rounded-lg">
                      <AvatarImage src={member.image} alt={member.name} className="object-cover" />
                      <AvatarFallback className="font-default text-4xl bg-muted text-muted-foreground">
                        {member.name.charAt(0)}
                      </AvatarFallback>
                    </Avatar>
                    <p className="text-center text-muted-foreground leading-relaxed font-sans font-light italic">
                      {member.bio}
                    </p>
                  </div>
                  <DrawerFooter className="pt-8">
                    <DrawerClose asChild>
                      <Button variant="outline" className="w-full sm:w-auto mx-auto font-sans font-light border-border hover:bg-accent">
                        Close Profile
                      </Button>
                    </DrawerClose>
                  </DrawerFooter>
                </div>
              </DrawerContent>
            </Drawer></SafeHydrate>)}
        </div>
      </div>
    </section>;
}